import { css } from '@emotion/css'

import { spacing, breakpoint, fontSize, mediaQueryHelper, colors } from '@offerzen/pinata-shame'

const experienceWidth = 260
const roleWidth = 230

const styles = {
  wrapper: css({
    marginBottom: spacing.medium,
  }),

  fieldRow: css({
    marginBottom: spacing.medium,

    [mediaQueryHelper(breakpoint.phone)]: {
      display: 'flex',
    },
  }),

  fieldGroup: css({
    [mediaQueryHelper(breakpoint.phone, 'max-width')]: {
      '& + & > label': {
        marginTop: spacing.default,
      },
    },

    [mediaQueryHelper(breakpoint.phone)]: {
      ':first-child': {
        marginRight: spacing.default,
      },
    },
  }),

  field: css({
    width: '100%',

    ul: {
      // Prevent page movement on select box open
      maxHeight: 240,
    },

    [mediaQueryHelper(breakpoint.phone, 'max-width')]: {
      width: '100%',
    },
  }),

  buttonGroup: css({
    paddingBottom: spacing.medium,
    borderBottom: `dashed 1px ${colors.mystic}`,
    display: 'flex',
    justifyContent: 'flex-end',
  }),

  cancelButton: css({
    marginRight: spacing.default,
    fontSize: fontSize.default,
  }),

  experienceFieldGroup: css({
    [mediaQueryHelper(breakpoint.phone)]: {
      // Force specific size to accommodate placeholder text
      width: experienceWidth,
    },
    [mediaQueryHelper(breakpoint.phone, 'max-width')]: {
      marginTop: spacing.default,
    },
  }),

  roleFieldGroup: css({
    [mediaQueryHelper(breakpoint.phone)]: {
      flexGrow: 1,
    },
  }),

  rolesOptions: css({
    [mediaQueryHelper(breakpoint.phone)]: {
      maxWidth: roleWidth,
    },
  }),
}

export default styles
